<template>
<div class="settlement max-width">

		<!-- 顶部 -->
		<div class='stl_title'>
			<!-- 页面标题 -->
			<div class='stl_tit_pagename fontweight-bo font-24 color-prompt no-copy'>订单结算</div>
			<!-- 流程图 -->
			<div class='stl_tit_process'>
				<div v-for='(item,index) in process' :key='item.id' 
					 :class="{'stl_tit_proc_view color-prompt-then':true, 'color-shallow-then':item.status==='past', 'color':item.status==='now'}">
					<!-- 提示文字 -->
					<div class='stl_tit_proc_vi_prompt font-12'>{{item.prompt}}</div>
					<!-- 提示索引 -->
					<div class='stl_tit_proc_vi_point no-copy font-16'>
						<span v-if="item.status !== 'now'">{{index+1}}</span>
						<img v-else class='stl_tit_proc_vi_point_img' src='@/assets/icon/success.png' />
					</div>
				</div>
			</div>
		</div>

	<div class='stl_model'>
		<div class='stl_model_title fontweight-bo fontcolor-16'>订单详情</div>
		<!-- 每个订单产品-块视图 -->
		<div v-for='(item,index) in order_product' :key="'x0'+index+item.id" class='stl_order_model'>
			<div class='stl_order_prompt no-copy fontcolor-14'>
				<div>订单 {{index+1}}</div>
				<div>
					<!-- <span class='color-prompt'>操作&nbsp;&nbsp;</span>
					<span class='stl_order_prompt_opera_view color-shallow-then font-hover'>添加备注</span> -->
				</div>
			</div>
			<div class='stl_order'>
				<div class='stl_order_view_wide'>
					<div class='stl_order_view_name fontcolor-14'>原文件名:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{trolley[index].uploadedfilenameold_modify ? trolley[index].uploadedfilenameold_modify : trolley[index].uploadedfilenameold}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>成品尺寸:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.xxx}} x {{item.yyy}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>单双面:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.ds === 1 ? '单面印刷' : (item.ds === 2 ? '双面印刷' : '未定义')}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>材料名称:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.material}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>材料克重:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.kg}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>印刷颜色:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.ysyanse === '0' ? '无' : (item.ysyanse === '1' ? '单色' : (item.ysyanse === '2' ? '双色' : (item.ysyanse === '4' ? '彩色' : item.ysyanse)))}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>印刷数量:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.shuliang}}</div>
					</div>
				</div>
				<div class='stl_order_view_wide2'>
					<div class='stl_order_view_name fontcolor-14'>后道工序:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{item.hjg}}</div>
					</div>
				</div>
				<div class='stl_order_view'>
					<div class='stl_order_view_name fontcolor-14'>订单金额:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<div class='stl_order_view_value_span'>{{trolley[index].offerInfoPrice}}元</div>
					</div>
				</div>
				<!-- 订单备注 -->
				<div class='stl_order_view_wide_then'>
					<div class='stl_order_view_name fontcolor-14'>订单备注:</div>
					<div class='stl_order_view_value fontcolor-14-shallow'>
						<input class='stl_order_view_value_input' placeholder='在此输入备注' v-model='item.gRemark' />
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class='stl_model'>
		<div class='stl_model_title fontweight-bo fontcolor-16'>收货人信息</div>
		<div class='stl_address'>
			<!-- 选择的收货人信息 -->
			<div class='stl_address_title fontcolor-15'>
				<div class='stl_address_title_view'>
					<div class='stl_address_title_vi_name'>收货人:</div>
					<div class='stl_address_title_vi_value'>{{address_info.rsrvstr1 ? address_info.rsrvstr1 : '未选'}}</div>
				</div>
				<div class='stl_address_title_view'>
					<div class='stl_address_title_vi_name'>联系电话:</div>
					<div class='stl_address_title_vi_value'>{{address_info.rsrvstr4 ? address_info.rsrvstr4 : '未选'}}</div>
				</div>
				<div class='stl_address_title_view'>
					<div class='stl_address_title_vi_name'>收货公司:</div>
					<div class='stl_address_title_vi_value'>{{address_info.rsrvstr2 ? address_info.rsrvstr2 : '未选'}}</div>
				</div>
				<div class='stl_address_title_view'>
					<div class='stl_address_title_vi_name'>收货地址:</div>
					<div class='stl_address_title_vi_value'>{{address_info.address ? address_info.province + address_info.city + address_info.area + address_info.address : '未选'}}</div>
				</div>
				<div class='stl_address_title_view'>
					<div class='stl_address_title_vi_name'>是否默认:</div>
					<div class='stl_address_title_vi_value'>{{address_info.isdefault === 1 ? '是' : '否'}}</div>
				</div>
			</div>
			<!-- 操作 -->
			<div class='stl_address_opear no-copy'>
				<div class='stl_address_opear_left fontcolor-15'>地址操作:</div>
				<div class='stl_address_opear_right'>
					<div v-for='item in address_opear' :key='item.id' 
						:class="{'stl_address_opear_view font-14':true, 'color':item.executable, 'color-prompt':!item.executable}" 
						:data-opera='item.opera' 
						@click='func_addressOpera'>
						<img class='stl_address_opear_view_icon' 
							:src='item.executable ? item.icon[1] : item.icon[0]' 
							:data-opera='item.opera' />
						<div :data-opera='item.opera'>{{item.name}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class='stl_model'>
		<div class='stl_model_title2 fontweight-bo fontcolor-16'>
			<div class='stl_model_tit2_view'>配送方式</div>
			<div class='stl_model_tit2_view'>订单结算</div>
			<div class='stl_model_tit2_view'>支付方式</div>
		</div>
		<div class='stl_llp'>
			<!-- 配送方式 -->
			<div class='stl_model_logisticsway no-copy stl_llp_view'>
				<template v-for='(item,index) in logisticsway'>
					<div :key='item.id' 
						:class="{'stl_model_logiw_view font-14 color-prompt no-newline':true, 'stl_model_logiw_view_bordercolor':!item.choose, 'color border-color':item.choose}" 
						@click="func_logisticsway(index)">
						<img class='stl_model_logiw_vi_icon' :src='item.choose ? item.icon[1] : item.icon[0]' />
						<div>{{item.name}}</div>
					</div>
				</template>
				<div class='stl_model_logiw_vi_prompt'>{{userinfo.loginip}}</div>
			</div>
			<!-- 订单结算 -->
			<div class='stl_liqui stl_llp_view'>
				<div v-for='item in liquidation' :key='item.id' class='stl_liqui_line'>
					<div class='stl_liqui_line_name fontcolor-15'>{{item.name}}:</div>
					<div v-if='item.isPrice' class='stl_liqui_line_value_price font-12'>￥</div>
					<div class='stl_liqui_line_value font-20'>{{item.value}}</div>
				</div>
			</div>
			<!-- 支付方式 -->
			<div class='stl_payway stl_llp_view'>
				<div class='stl_payway_line no-copy'>
					<div v-for='(item,index) in payway' :key='item.id' 
						:class="{'stl_payway_li_view font-14 color-prompt no-newline':true, 'stl_payway_li_view_bordercolor':!item.choose, 'color border-color':item.choose}" 
						@click="func_payway(index)">
						<img class='stl_payway_li_vi_icon' :src='item.choose ? item.icon[1] : item.icon[0]' />
						<div>{{item.name}}</div>
					</div>
				</div>
				<div class='stl_payway_prompt fontcolor-18-shallow'>
					<!-- <div class='stl_payway_prompt_view'>信用额度: ￥{{userDeposit.quota}}</div> -->
					<div class='stl_payway_prompt_view'>预存款: ￥{{userDeposit.moneys}}</div>
				</div>
			</div>
		</div>
	</div>

	<div class='stl_warmPrompt'>
		<div class='stl_wapt_line'>
			<div :class="{'stl_wapt_line_icon':true, 'stl_wapt_line_icon_cancel':!agreement}" @click='func_agreement'>
				<img v-if='agreement' class='stl_wapt_line_icon_img' src='@/assets/icon/agree_agreement.png' />
			</div>
			<div :class="{'stl_wapt_line_value font-14':true, 'color-prompt':!agreement, 'color':agreement}" 
				 >提交订单前, 请您确认订单信息无误。下单人承诺：所提供资料（含知识产权）真实、合法，由此引发的所有问题由下单人负责。此订单等同于印刷委托书
			</div>
		</div>
	</div>

	<div class='stl_button no-copy'>
		<div class='stl_button_view stl_button_view_cancel fontweight-bo' @click='func_turnBack'>返回上一页</div>
		<div class='stl_button_view stl_button_view_submit bgcolor-gradient-right' @click='func_orderSubmit'>提交订单</div>
	</div>



	<v-addressList ref='vadl'></v-addressList>
	<v-addressEditor ref='vade'></v-addressEditor>
	<v-addressCreate ref='vadc'></v-addressCreate>
</div>
</template>

<script>
// 图标
	import pwyck from '@/assets/icon/payway_yucunkuan.png';
	import pwycked from '@/assets/icon/payway_yucunkuan_ed.png';
	import pwzx from '@/assets/icon/payway_zaixian.png';
	import pwzxed from '@/assets/icon/payway_zaixian_ed.png';
	import lwsm from '@/assets/icon/logisticsway_shangmen.png';
	import lwsmed from '@/assets/icon/logisticsway_shangmen_ed.png';
	import lwhy from '@/assets/icon/logisticsway_huoyun.png';
	import lwhyed from '@/assets/icon/logisticsway_huoyun_ed.png';
	import lwkd from '@/assets/icon/logisticsway_kuaidi.png';
	import lwkded from '@/assets/icon/logisticsway_kuaidi_ed.png';
	import lwshsm from '@/assets/icon/logisticsway_shsm.png';
	import lwshsmed from '@/assets/icon/logisticsway_shsm_ed.png';
	import opmr from '@/assets/icon/opera_moren.png';
	import opmred from '@/assets/icon/opera_moren_ed.png';
	import opbj from '@/assets/icon/opera_bianji.png';
	import opbjed from '@/assets/icon/opera_bianji_ed.png';
	import opqt from '@/assets/icon/opera_qita.png';
	import opqted from '@/assets/icon/opera_qita_ed.png';
	import opxz from '@/assets/icon/opera_xinzeng.png';
	import opxzed from '@/assets/icon/opera_xinzeng_ed.png';

import addressList from '@/components/address/addressList';
import addressEditor from '@/components/address/addressEditor';
import addressCreate from '@/components/address/addressCreate';

import {req_bjlogInfo, req_orderCreate} from '@/services/order';
import {req_userAddressList, req_userAddressCreate, req_userAddressSetDefault, req_userAddressSetModify, req_userDeposit} from '@/services/user';

export default {
	name: 'settlement',
	components: {
		'v-addressList': addressList,
		'v-addressEditor': addressEditor,
		'v-addressCreate': addressCreate,
	},
	data() {
		return {
			process: [
				{id:'pre01', prompt:'选择商品、规格', 	status:'past'},
				{id:'pre02', prompt:'填写核对订单信息', status:'now'},
				{id:'pre03', prompt:'成功提交订单', 	status:'future'},
			],
			payway: [//支付方式
				{id:'pwyck', name:'预存款扣费', icon:[pwyck, pwycked], value:'0', choose:true,},
				{id:'pwzx',  name:'在线支付',	icon:[pwzx, pwzxed],   value:'1', choose:false,},
			],
			logisticsway: [//出货方式
				{id:'lwsm',   name:'自取',				icon:[lwsm, lwsmed], value:'0', choose:true},
				{id:'lwkd',   name:'快递',	 icon:[lwhy, lwhyed], value:'2', choose:false},
				{id:'lwwl',   name:'物流送货上门',	 icon:[lwhy, lwhyed], value:'3', choose:false},
			],
			address_opear: [
				{id:'adop01', name:'设为默认', opera:'setDefault',	  executable:false, icon:[opmr, opmred]},
				{id:'adop02', name:'编辑地址', opera:'editorAddress', executable:true,  icon:[opbj, opbjed]},
				{id:'adop03', name:'切换地址', opera:'otherAddress',  executable:true,  icon:[opqt, opqted]},
				{id:'adop04', name:'新增地址', opera:'createAddress', executable:true,  icon:[opxz, opxzed]},
			],
			liquidation: [//清算
				{id:'liq01', name:'订单数量', value:'0', isPrice:false,},
				{id:'liq02', name:'物流费用', value:'0', isPrice:true,},
				{id:'liq03', name:'印刷费用', value:'0', isPrice:true,},
				{id:'liq04', name:'总计费用', value:'0',  isPrice:true,},
			],
			agreement: true,//同意协议
			userinfo: false,
			trolley: [],
			order_product: [],//所有订单bjlog信息
			userDeposit: false,//用户信用额度
			address_info: {},//选中的、展示用的用户地址信息
			address_list: [],//用户所有地址列表
			isRoute: false
		}
	},
	methods: {
		// 返回上页
		func_turnBack() {
			this.$router.go(-1);
		},
		// 切换支付方式
		func_payway(index) {
			if (!this.payway[index]['choose']) {
				for (let i in this.payway) {
					if (this.payway[i]['choose']) {
						this.payway[i]['choose'] = false;
						this.payway[index]['choose'] = true;
						break;
					}
				}
			}
		},
		// 切换出货方式
		func_logisticsway(index) {
			if (!this.logisticsway[index]['choose']) {
				for (let i in this.logisticsway) {
					if (this.logisticsway[i]['choose']) {
						this.logisticsway[i]['choose'] = false;
						this.logisticsway[index]['choose'] = true;
						break;
					}
				}
			}
		},
		// 收货人信息的-操作按钮
		func_addressOpera(event) {
			const opera = event.target.dataset.opera;
			switch (opera) {
				// 设为默认
				case 'setDefault': {
					if (!this.address_opear[0]['executable']) {
						this.func_defaultAddress();
					}
					break;
				}
				//编辑地址
				case 'editorAddress': {
					this.$refs.vade.vade_Change(this.address_info);
					break;
				}
				//其他地址
				case 'otherAddress': {
					this.$refs.vadl.vadl_Change(this.address_list);
					break;
				}
				// 新增地址
				case 'createAddress': {
					this.$refs.vadc.vadc_Change();
					break;
				}
			}
		},
		// 地址列表组件回调-切换地址
		vadl_callback(index) {
			setTimeout(() => {
				this.address_info = this.address_list[index];
				if (this.address_info['isdefault'] !== 1) {
					this.address_opear[0]['executable'] = false;
				} else {
					this.address_opear[0]['executable'] = true;
				}
			}, 300)
		},
		// 编辑地址组件回调-编辑地址
		async func_editorAddress(params) {
			this.$parent.loadingChange(true, '修改中....');
			const result = await req_userAddressSetModify(this.address_info['id'], params['Address'], params['province'], params['city'], params['area'], params['name'], params['company'], params['phone']);
			this.$parent.loadingChange(false);
			if (result.success) {
				this.$parent.msgChange('success', '修改地址成功', '', 3000);
				this.func_userAddressList(this.address_info['id']);
			} else {
				this.$parent.msgChange('fail', '修改地址失败', result.msg);
			}
		},
		// 新增地址组件回调-新增地址
		async func_createAddress(params) {
			this.$parent.loadingChange(true, '正在创建地址....');
			const result = await req_userAddressCreate(this.userinfo['userid'], params['Address'], params['Attn'], params['Company'], params['Mobile'], params['province'], params['city'], params['area']);
			this.$parent.loadingChange(false);
			if (result.success) {
				this.$parent.msgChange('success', '新增地址成功', result.msg);
				this.func_userAddressList('create-address');
			} else {
				this.$parent.msgChange('fail', '新增地址失败', result.msg);
			}
		},
		// 设置默认地址
		async func_defaultAddress() {
			this.$parent.loadingChange(true, '修改默认地址中....');
			const result = await req_userAddressSetDefault(this.address_info['id'], this.userinfo['userid']);
			this.$parent.loadingChange(false);
			if (result.success) {
				this.$parent.msgChange('success', '设置成功', '');
				this.func_userAddressList();
			} else {
				this.$parent.msgChange('fail', '修改默认地址失败', result.msg);
			}
		},
		// 同意/拒绝 协议
		func_agreement() {
			if (this.agreement) {
				this.agreement = false;
			} else {
				this.agreement = true;
			}
		},
		// 提交订单
		async func_orderSubmit() {
			if (!this.agreement) {
				this.$parent.msgChange('warning', '请同意下单协议', '');
				return;
			}
			// 物流方式
			let wuliu = false;
				for (let i in this.logisticsway) {
					if (this.logisticsway[i]['choose']) {
						wuliu = this.logisticsway[i]['value'];
						break;
					}
				}
			// 支付方式
			let payment = false;
				for (let i in this.payway) {
					if (this.payway[i]['choose']) {
						payment = this.payway[i]['value'];
						break;
					}
				}
			// 收货地址
			if (!this.address_info['id']) {
				this.$parent.msgChange('warning', '请选择收货人信息', '');
				return;
			} else if (!this.address_info['rsrvstr1'] || !this.address_info['rsrvstr4'] || !this.address_info['rsrvstr2'] || !this.address_info['province'] || !this.address_info['city'] || !this.address_info['area'] || !this.address_info['address']) {
				this.$parent.confirmChange('warning', '请先完善收货人信息', () => {
					this.$refs.vade.vade_Change(this.address_info);
				}, () => {}, {yes:'立即完善', no:'取消'});
				return;
			}

			if (payment === '0') { /* 预存款扣费 */
				const canPay = parseInt(this.userDeposit.quota) + parseInt(this.userDeposit.moneys);
				const finalSumPrice = parseFloat(this.liquidation[3]['value']);
				if (canPay >= finalSumPrice) {
					//循环订单列表-提交订单
					let failArr = [];//提交失败的订单
					this.$parent.loadingChange(true, '提交订单中');
					for (let i in this.order_product) {
						
						const result = await req_orderCreate(this.userinfo.userid, this.trolley[i].bid, this.trolley[i].uploadedfilename, this.trolley[i].uploadedfilepath, this.userinfo.company, this.address_info.rsrvstr2, this.address_info.rsrvstr1, this.address_info.rsrvstr4, this.address_info.address, this.order_product[i].gRemark, this.order_product[i].finalprice, wuliu, payment, this.trolley[i].uploadedfilesize, this.trolley[i].offerInfoString);
						/* const result = await req_orderCreate(this.userinfo.userid, this.trolley[i].bid, this.trolley[i].uploadedfilename, this.trolley[i].uploadedfilepath, this.userinfo.company, this.address_info.rsrvstr2, this.address_info.rsrvstr1, this.address_info.rsrvstr4, this.address_info.address, this.order_product[i].gRemark, this.trolley[i].offerInfoPrice, wuliu, payment, this.trolley[i].uploadedfilesize, this.trolley[i].offerInfoString); */
						//提交失败-添加索引到failArr;
						if (!result.success) {
							failArr.push(i);
						}
					}
					this.$parent.loadingChange(false);

					// 更新缓存用户信息
					this.$parent.func_appUpdateUserinfo();
					if (failArr.length < 1) {
						this.$parent.confirmChange('success', '订单下单成功', () => {
							this.STORAGE.set('g_trollerList', []);
							this.$parent.func_tabbar_trolley();
							if (!this.isRoute) {
								this.isRoute = true;
								this.$router.push({
									name: 'orderManege',
								});
							}
						}, () => {}, {yes:'查看我的订单', no:''});
						setTimeout(() => {
							if (!this.isRoute) {
								this.isRoute = true;
								this.STORAGE.set('g_trollerList', []);
								this.$parent.func_tabbar_trolley();
								this.$router.push({
									name: 'orderManege',
								});
							}
						}, 3000)
					} else {
						this.$parent.confirmChange('success', '订单下单成功，'+failArr.length+'条订单提交失败，已退回购物车', () => {
							let arr = [];
							for (let i in failArr) {
								arr.push(this.trolley[failArr[i]]);
							}
							this.STORAGE.set('g_trollerList', arr);
							this.$router.push({
								name: 'orderManege',
							});
						}, () => {}, {yes:'查看我的订单', no:''});
					}

				} else {
					this.$parent.loadingChange(false);
					this.$parent.msgChange('fail', '可支配金额不足以支付订单', '');
				}

			} else if (payment === '1') { /* 在线支付 */
				const finalSumPrice = parseFloat(this.liquidation[3]['value']);

				//循环订单列表-提交订单
				let failArr = [];//提交失败的订单
				let oidArr = '';//所有订单id
				this.$parent.loadingChange(true, '提交订单中');
				for (let i in this.order_product) {
					const result = await req_orderCreate(this.userinfo.userid, this.trolley[i].bid, this.trolley[i].uploadedfilename, this.trolley[i].uploadedfilepath, this.userinfo.company, this.address_info.rsrvstr2, this.address_info.rsrvstr1, this.address_info.rsrvstr4, this.address_info.address, this.order_product[i].gRemark, this.order_product[i].finalprice, wuliu, payment, this.trolley[i].uploadedfilesize, this.trolley[i].offerInfoString);
					/* const result = await req_orderCreate(this.userinfo.userid, this.trolley[i].bid, this.trolley[i].uploadedfilename, this.trolley[i].uploadedfilepath, this.userinfo.company, this.address_info.rsrvstr2, this.address_info.rsrvstr1, this.address_info.rsrvstr4, this.address_info.address, this.order_product[i].gRemark, this.trolley[i].offerInfoPrice, wuliu, payment, this.trolley[i].uploadedfilesize, this.trolley[i].offerInfoString); */
					//提交失败-添加索引到failArr;
					if (!result.success) {
						failArr.push(i);
					} else {
						if (oidArr === '') {
							oidArr += result.data;
						} else {
							oidArr += ','+result.data;
						}
					}
				}
				this.$parent.loadingChange(false);

				// 更新缓存用户信息
				this.$parent.func_appUpdateUserinfo();
				if (failArr.length < 1) {
					this.$parent.confirmChange('success', '注意：您的订单尚未下单成功，扫码支付后订单才会安排下单生产，如未支付，由此产生的货期问题由客户自行承担。', () => {
						this.STORAGE.set('g_trollerList', []);
						//缓存onlinePay参数
						this.STORAGE.set('g_orderInfoEd', {
							orderId: oidArr,
							total: finalSumPrice
						});
						this.$router.push({
							name: 'onlinePay',
						});
					}, () => {}, {yes:'去支付', no:''});
				} else {
					this.$parent.confirmChange('success', '注意：您的订单尚未下单成功，扫码支付后订单才会安排下单生产，如未支付，由此产生的货期问题由客户自行承担。 【'+failArr.length+'条订单提交失败，已退回购物车】', () => {
						let arr = [];
						for (let i in failArr) {
							arr.push(this.trolley[failArr[i]]);
						}
						this.STORAGE.set('g_trollerList', arr);

						//缓存onlinePay参数
						this.STORAGE.set('g_orderInfoEd', {
							orderId: oidArr,
							total: finalSumPrice
						});

						this.$router.push({
							name: 'orderManege',
						});
					}, () => {}, {yes:'去支付', no:''});
				}
			} else {
				this.$parent.msgChange('warning', '支付方式异常', '');
			}
		},
		// ===========================================================================================================================================
		// 根据购物车-获取订单产品信息
		async func_orderProductAll() {
			this.$parent.loadingChange(true);
			this.trolley = this.STORAGE.get('g_trollerList');
			this.order_product = [];
			//请求bjlog信息失败的订单
			let failArr = [];
			for (let i in this.trolley) {
				// 请求该订单bjlog信息
				const result = await req_bjlogInfo(this.trolley[i].bid);
				if (result.success) {
					// 设置备注
					if (this.trolley[i]['remark']) {
						result.data.gRemark = this.trolley[i]['remark'];
					} else {
						result.data.gRemark = '';
					}
					if (!result.data.lians || result.data.lians < 1) {
						result.data.lians = 1;
					}
					// 总计费用
					// this.liquidation[3]['value'] = (parseFloat(this.liquidation[3]['value']) + parseFloat(result.data.sumprice)).toFixed(2);
					this.liquidation[3]['value'] = (parseFloat(this.liquidation[3]['value']) + parseFloat(result.data.finalprice)).toFixed(2);
					this.order_product.push(result.data);
				} else {
					failArr.push(this.trolley[i]);
				}
			}
			if (failArr.length > 0) {
				this.$parent.confirmChange('fail', '由于您的购物车中, 有'+failArr.length+'笔订单查询详细信息失败, 无法提交。请返回重新处理购物车内容, 或联系客服帮助解决。', () => {
					this.func_turnBack();
				}, () => {
					window.open('tencent://message/?uin=800180939');
					this.func_turnBack();
				}, {yes:'知道了', no:'联系客服'});
			}
			// 订单数量
			this.liquidation[0]['value'] = this.order_product.length;
			this.$parent.loadingChange(false);
		},
		//获取预存款、信用额度
		async func_userDeposit() {
			this.$parent.loadingChange(true);
			const result = await req_userDeposit(this.userinfo['userid']);
			if (result.success) {
				this.$parent.loadingChange(false);
				this.userDeposit = result.data;
			} else {
				this.$parent.loadingChange(false);
			}
		},
		// 获取更新用户地址列表
		async func_userAddressList(id) {
			this.$parent.loadingChange(true);
			const result = await req_userAddressList(this.userinfo['userid']);
			if (result.success && result.data.length > 0) {
				this.address_list = result.data;

				if (id && id==='create-address') {
					this.address_info = this.address_list[this.address_list.length-1];
				} else {
					for (let i in this.address_list) {
						if (id) {
							if (this.address_list[i]['id'] === id) {
								this.address_info = this.address_list[i];
								break;
							}
						} else if (this.address_list[i]['isdefault'] === 1) {
							// 初始收货人信息
							this.address_info = this.address_list[i];
							this.address_opear[0]['executable'] = true;
							break;
						}
					}
				}
			}
			this.$parent.loadingChange(false);
		},
		// 全局初始化
		async func_init() {
			await this.func_orderProductAll();
			await this.func_userDeposit();
			await this.func_userAddressList();
		}
	},
	mounted() {
		this.userinfo = this.STORAGE.get('g_userInfo');

		if (this.userinfo && this.userinfo['userid']) {
			this.func_init();
		}
	}
}
</script>
<style src='@/style/settlement.css' scoped></style>



// WEBPACK FOOTER //
// src/pages/Settlement.vue